import React, { useState, useEffect } from 'react';
import { API_BASE } from '../App';

const MyTickets = ({ user, token, onBack }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyTickets();
  }, []);

  const fetchMyTickets = async () => {
    try {
      const response = await fetch(`${API_BASE}/my-tickets`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setTickets(data);
      }
    } catch (error) {
      console.error('Tickets yüklenirken hata:', error);
    }
    setLoading(false);
  };

  const getStatusLabel = (status) => {
    const labels = {
      open: '🔴 Açık',
      in_progress: '🟡 İşlemde',
      closed: '🟢 Kapalı',
      procurement: '🟣 Tedarik Sürecinde'
    };
    return labels[status] || status;
  };

  const getPriorityLabel = (priority) => {
    const labels = {
      low: '🟢 Düşük',
      normal: '🟡 Normal',
      high: '🟠 Yüksek',
      urgent: '🔴 Acil'
    };
    return labels[priority] || priority;
  };

  const getTypeLabel = (type) => {
    const labels = {
      ariza: '🔧 Arıza',
      sayim: '📊 Sayım',
      degisim: '🔄 Değişim',
      genel: '✉️ Genel'
    };
    return labels[type] || type;
  };

  return (
    <div className="container">
      <button onClick={onBack} className="btn-back">Geri Dön</button>
      <h2>Taleplerim</h2>
      
      {loading ? (
        <div className="loading">Yükleniyor...</div>
      ) : tickets.length === 0 ? (
        <div className="no-data">Henüz hiç talebiniz bulunmuyor.</div>
      ) : (
        <div className="tickets-list">
          {tickets.map(ticket => (
            <div key={ticket.id} className="ticket-card">
              <div className="ticket-header">
                <h3>{ticket.title}</h3>
                <div className="ticket-meta">
                  <span className="ticket-type">{getTypeLabel(ticket.type)}</span>
                  <span className="ticket-status">{getStatusLabel(ticket.status)}</span>
                  <span className="ticket-priority">{getPriorityLabel(ticket.priority)}</span>
                </div>
              </div>
              {ticket.product_name && (
                <p className="ticket-product">
                  <strong>İlgili Ürün:</strong> {ticket.product_name} ({ticket.product_code})
                </p>
              )}
              <p className="ticket-description">{ticket.description}</p>
              <div className="ticket-footer">
                <small>Oluşturulma: {new Date(ticket.created_at).toLocaleString('tr-TR')}</small>
                {ticket.updated_at !== ticket.created_at && (
                  <small>Güncelleme: {new Date(ticket.updated_at).toLocaleString('tr-TR')}</small>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyTickets;